import React from 'react';

import { Table as AntTable, TableProps } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { ViewProductSchema } from '@app/models/products';

import { SearchControls } from '@components/products';
import { useProductModal } from '@pages/Catalogs/providers';

import { BASE_COLUMNS } from './constants';
import { Container } from './styles';

interface IProps {
  isLoading: boolean;
  data?: ViewProductSchema[];
}

export const WarehouseTable: React.FC<IProps> = ({ data, isLoading }) => {
  const [y, setY] = React.useState<number>(400);
  const nomenclatureInfoT = useTranslation(NSKeys.nomenclatureInfo);

  const { selectedRows, onSelectChange } = useProductModal();

  React.useEffect(() => {
    const update = () => setY(window.innerHeight - 260);
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  const handletChange = (_: any, rows: any[]) => {
    onSelectChange(rows);
  };

  const rowSelection: TableProps<ViewProductSchema>['rowSelection'] = {
    selectedRowKeys: selectedRows?.map((el) => el.uid),
    onChange: handletChange,
  };

  return (
    <Container>
      <SearchControls maxTagCount="responsive" isLoading={isLoading} isViewSwitchVisible={false} />
      <AntTable<ViewProductSchema>
        columns={[
          ...BASE_COLUMNS.map((el, index) => ({
            ...el,
            title: nomenclatureInfoT.t(el.title as any),
            render: BASE_COLUMNS.find((baseCol) => baseCol.key === el.key)?.render,
          })),
        ]}
        rowSelection={rowSelection}
        size="middle"
        key="uid"
        rowKey="uid"
        pagination={false}
        className="tableClassname"
        loading={isLoading}
        dataSource={data}
        scroll={{ y }}
      />
    </Container>
  );
};
